export default "__VITE_ASSET__sFQvpUm4__"